import { createSelector } from '@reduxjs/toolkit';

import { createUrlWithFilter } from '~/atomic/atom/links/createUrlWithFilter';
import { pagesConfigStore } from '~/atomic/atom/links/pagesConfigStore';
import {
  catalogFilterFirstGenreSelector,
  catalogFilterIsCanDownloadBooksSelector,
  catalogFilterIsExclusiveSelector,
  catalogFilterIsFreeBooksSelector,
  catalogFilterIsHaveGenreSelector,
  catalogFilterIsHaveTagSelector, catalogFilterSelector,
  catalogPageTagSelector,
} from '~/feature/catalog/filter/catalogFilter.selector';
import { paginationTotalSelector } from '~/feature/pagination/pagination.selector';

export const metaCanonicalSelector = createSelector(
  catalogFilterSelector,
  ({
    isWithAbonnement,
    isCanDownload,
    tagSlug,
    isOnlyFree,
    mainGenreSlug,
    bookType,
    completeStatus,
    withAudiobook,
    sortingType,
  }) => {
    return createUrlWithFilter({
      startWith: pagesConfigStore.genre.url(),
      tagSlug,
      genreSlug: mainGenreSlug,
      isOnlyFree,
      isCanDownload,
      isWithAbonnement,
      bookType,
      withAudiobook,
      completeStatus,
      sortingType,
    });
  },
);

export const ogTitleSelector = createSelector(
  catalogFilterIsHaveTagSelector,
  catalogFilterIsHaveGenreSelector,
  catalogFilterIsFreeBooksSelector,
  catalogFilterIsExclusiveSelector,
  catalogFilterFirstGenreSelector,
  catalogPageTagSelector,
  catalogFilterIsCanDownloadBooksSelector,
  (isHaveTag, isHaveGenre, isFreeBooks, isExclusive, firstGenre, tag, isCanDownload) => {
    if (!isHaveGenre && !isHaveTag && !isFreeBooks && !isCanDownload && isExclusive) {
      return 'Эксклюзивные книги. Читайте только на Букривер';
    }

    if (!isHaveGenre && !isHaveTag && isFreeBooks && !isCanDownload) {
      return 'Читать и скачивать в fb2 книги бесплатно';
    }

    if (!isHaveGenre && !isHaveTag && isFreeBooks && isCanDownload) {
      return 'Читать и скачивать в fb2 книги бесплатно';
    }

    if (!isHaveGenre && !isHaveTag && !isFreeBooks && isCanDownload) {
      return 'Читать и скачивать в fb2 книги бесплатно';
    }

    if (isHaveGenre && !isHaveTag && !isFreeBooks && !isCanDownload) {
      return `Книги жанра ${firstGenre?.name} читать онлайн`;
    }

    if (isHaveGenre && !isHaveTag && isFreeBooks && !isCanDownload) {
      return `Книги жанра ${firstGenre?.name} читать онлайн бесплатно`;
    }

    if (isHaveGenre && !isHaveTag && !isFreeBooks && isCanDownload) {
      return `Книги жанра ${firstGenre?.name} | Скачать книги на Bookriver`;
    }

    if (isHaveGenre && !isHaveTag && isFreeBooks && isCanDownload) {
      return `Книги жанра ${firstGenre?.name} | Скачать книги на Bookriver бесплатно`;
    }

    if (isHaveGenre && isHaveTag && !isFreeBooks && !isCanDownload) {
      return `Читать ${firstGenre?.name} про ${tag?.nameVin} | Книги на Bookriver`;
    }

    if (isHaveGenre && isHaveTag && isFreeBooks && isCanDownload) {
      return `Читать ${
        firstGenre?.name
      } – про ${tag?.nameVin} | Скачать книги на Bookriver бесплатно`;
    }

    if (isHaveGenre && isHaveTag && !isFreeBooks && isCanDownload) {
      return `Читать ${
        firstGenre?.name
      } – про ${tag?.nameVin} | Скачать книги на Bookriver`;
    }

    if (isHaveGenre && isHaveTag && isFreeBooks && !isCanDownload) {
      return `Читать ${firstGenre?.name} про ${tag?.nameVin} | Книги на Bookriver бесплатно`;
    }

    return 'Читать и скачивать в fb2 книги';
  },
);

export const h1ContentSelector = createSelector(
  catalogFilterIsHaveTagSelector,
  catalogFilterIsHaveGenreSelector,
  catalogFilterIsFreeBooksSelector,
  catalogFilterIsExclusiveSelector,
  catalogFilterFirstGenreSelector,
  catalogPageTagSelector,
  catalogFilterIsCanDownloadBooksSelector,
  (isHaveTag, isHaveGenre, isFreeBooks, isExclusive, firstGenre, tag, isCanDownload) => {
    if (!isHaveGenre && !isHaveTag && !isFreeBooks && !isCanDownload && isExclusive) {
      return 'Эксклюзивные книги';
    }

    if (!isHaveGenre && !isHaveTag && !isFreeBooks && !isCanDownload) {
      return 'Все книги';
    }

    if (!isHaveGenre && !isHaveTag && isFreeBooks && !isCanDownload) {
      return 'Все бесплатные книги';
    }

    if (!isHaveGenre && !isHaveTag && isFreeBooks && isCanDownload) {
      return 'Все бесплатные книги скачать в fb2';
    }

    if (!isHaveGenre && !isHaveTag && !isFreeBooks && isCanDownload) {
      return 'Скачать книги в fb2';
    }

    if (isHaveGenre && !isHaveTag && !isFreeBooks && !isCanDownload) {
      return `${firstGenre?.name}`;
    }

    if (isHaveGenre && !isHaveTag && isFreeBooks && !isCanDownload) {
      return `${firstGenre?.name} бесплатно`;
    }

    if (isHaveGenre && !isHaveTag && !isFreeBooks && isCanDownload) {
      return `${firstGenre?.name} скачать книги в fb2`;
    }

    if (isHaveGenre && !isHaveTag && isFreeBooks && isCanDownload) {
      return `${firstGenre?.name} скачать бесплатно в fb2`;
    }

    if (isHaveGenre && isHaveTag && !isFreeBooks && !isCanDownload) {
      return `${firstGenre?.name} про ${tag?.nameVin}`;
    }

    if (isHaveGenre && isHaveTag && isFreeBooks && isCanDownload) {
      return `${firstGenre?.name} про ${tag?.nameVin} скачать бесплатно в fb2`;
    }

    if (isHaveGenre && isHaveTag && !isFreeBooks && isCanDownload) {
      return `${firstGenre?.name} про ${tag?.nameVin} скачать книги в fb2`;
    }

    if (isHaveGenre && isHaveTag && isFreeBooks && !isCanDownload) {
      return `${firstGenre?.name} про ${tag?.nameVin} бесплатно`;
    }
  },
);

export const ogDescriptionSelector = createSelector(
  catalogFilterIsHaveTagSelector,
  catalogFilterIsHaveGenreSelector,
  catalogFilterIsFreeBooksSelector,
  catalogFilterIsExclusiveSelector,
  catalogFilterFirstGenreSelector,
  catalogPageTagSelector,
  catalogFilterIsCanDownloadBooksSelector,
  (isHaveTag, isHaveGenre, isFreeBooks, isExclusive, firstGenre, tag, isCanDownload) => {
    if (!isHaveGenre && !isHaveTag && !isFreeBooks && !isCanDownload && isExclusive) {
      return 'Книги, которые можно найти только на Букривер.';
    }

    if (!isHaveGenre && !isHaveTag && !isFreeBooks && !isCanDownload) {
      return 'Прекрасная библиотека книг с рекомендательной системой.';
    }

    if (!isHaveGenre && !isHaveTag && isFreeBooks && !isCanDownload) {
      return 'Прекрасная библиотека книг с рекомендательной системой.';
    }

    if (!isHaveGenre && !isHaveTag && isFreeBooks && isCanDownload) {
      return 'Прекрасная библиотека книг с рекомендательной системой.';
    }

    if (isHaveGenre && !isHaveTag && !isFreeBooks && !isCanDownload) {
      return ` Читайте лучшие книги ${firstGenre?.name} на площадке Bookriver ⭐ `
        + 'Библиотека произведений ⭐'
        + 'Скачать полностью книги в формате fb2 ⭐'
        + 'Читайте на нашем сайте или в удобном приложении для Android и айфона';
    }

    if (isHaveGenre && !isHaveTag && isFreeBooks && !isCanDownload) {
      return `Книги жанра ${firstGenre?.name} читать на литературно-издательской`
        + ' площадке Bookriver бесплатно'
        + ' ⭐ Серии по жанрам ⭐ Полная библиотека произведений ⭐ '
        + ' Скачать полностью книги в формате fb2 ⭐ Авторские серии романов и рассказов '
        + ' ✉ Ищете и читайте интересных авторов на нашем сайте';
    }

    if (isHaveGenre && !isHaveTag && !isFreeBooks && isCanDownload) {
      return `Книги жанра ${firstGenre?.name} скачать на литературно-издательской`
        + ' площадке Bookriver'
        + ' ⭐ Серии по жанрам ⭐ Полная библиотека произведений ⭐ '
        + ' Скачать полностью книги в формате fb2 ⭐ Авторские серии романов и рассказов '
        + ' ✉ Ищете и читайте интересных авторов на нашем сайте';
    }

    if (isHaveGenre && !isHaveTag && isFreeBooks && isCanDownload) {
      return `Книги жанра ${firstGenre?.name} скачать на литературно-издательской`
        + ' площадке Bookriver бесплатно'
        + ' ⭐ Серии по жанрам ⭐ Полная библиотека произведений ⭐ '
        + ' Скачать полностью книги в формате fb2 ⭐ Авторские серии романов и рассказов '
        + ' ✉ Ищете и читайте интересных авторов на нашем сайте';
    }

    if (isHaveGenre && isHaveTag && !isFreeBooks && !isCanDownload) {
      return `${firstGenre?.name} читать на литературно-издательской площадке`
        + ' Bookriver ⭐ Серии книг по жанрам ⭐ Полная библиотека произведений'
        + ' ⭐ Скачать полностью книги в формате fb2⭐ Авторские серии романов и рассказов'
        + ' ✉ Найти работы авторов на нашем сайте и приобретайте свою коллекцию';
    }

    if (isHaveGenre && isHaveTag && isFreeBooks && !isCanDownload) {
      return `${firstGenre?.name} читать на литературно-издательской площадке`
        + ' Bookriver ⭐ бесплатно Серии книг по жанрам ⭐ Полная библиотека произведений'
        + ' ⭐ Скачать полностью книги в формате fb2⭐ Авторские серии романов и рассказов'
        + ' ✉ Найти работы авторов на нашем сайте и приобретайте свою коллекцию';
    }

    if (isHaveGenre && isHaveTag && isFreeBooks && isCanDownload) {
      return `${firstGenre?.name} скачать на литературно-издательской площадке`
        + ' Bookriver ⭐ бесплатно Серии книг по жанрам ⭐ Полная библиотека произведений'
        + ' ⭐ Скачать полностью книги в формате fb2⭐ Авторские серии романов и рассказов'
        + ' ✉ Найти работы авторов на нашем сайте и приобретайте свою коллекцию';
    }

    if (isHaveGenre && isHaveTag && !isFreeBooks && isCanDownload) {
      return `${firstGenre?.name} скачать на литературно-издательской площадке`
        + ' Bookriver ⭐ Серии книг по жанрам ⭐ Полная библиотека произведений'
        + ' ⭐ Скачать полностью книги в формате fb2⭐ Авторские серии романов и рассказов'
        + ' ✉ Найти работы авторов на нашем сайте и приобретайте свою коллекцию';
    }
  },
);

export const isHidePageSelector = createSelector(
  catalogFilterIsHaveTagSelector,
  catalogFilterIsHaveGenreSelector,
  catalogFilterIsFreeBooksSelector,
  paginationTotalSelector,
  catalogFilterIsCanDownloadBooksSelector,
  (isHaveTag, isHaveGenre, isFreeBooks, booksTotal, isCanDownload) => {
    if (!isHaveGenre && !isHaveTag && !isFreeBooks && !isCanDownload && booksTotal === 0) {
      return true;
    }

    if ((isHaveGenre || isHaveTag || isFreeBooks || isCanDownload) && booksTotal < 3) {
      return true;
    }

    return false;
  },
);

export const genrePageSeoSelector = createSelector(
  metaCanonicalSelector,
  h1ContentSelector,
  ogTitleSelector,
  ogDescriptionSelector,
  isHidePageSelector,
  (metaCanonical, h1Content, ogTitle, ogDescription, isHidePage) => ({
    meta: { canonical: metaCanonical },
    og: { title: ogTitle, description: ogDescription },
    h1: h1Content,
    isHidePage,
  }),
);
